import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Box } from "@gemini/core";
import { IndividualPrice } from "@/components/Sections/Price/RentView/IndividualPrice";
export const PriceUnitDetails = ({ details }) => {
    if (!details)
        return null;
    return (_jsx(_Fragment, { children: details.map((detail, index) => {
            var _a;
            return (_jsx(Box, { children: _jsxs(Box, { marginBottom: index === details.length - 1 ? "spacing.none" : "spacing.16", children: [(detail === null || detail === void 0 ? void 0 : detail.label) && (_jsx(Box, { typography: "typography.body.14.regular", color: "color.content.subdued.default", marginBottom: "spacing.16", children: detail.label })), (_a = detail === null || detail === void 0 ? void 0 : detail.prices) === null || _a === void 0 ? void 0 : _a.map((price, index) => (_jsx(IndividualPrice, { price: price, isLast: index === detail.prices.length - 1 }, price.key)))] }) }, detail.key));
        }) }));
};
